goog.provide("shadow.js.shim.module$$mui$material$Switch");
goog.provide("module$shadow_js_shim_module$$mui$material$Switch");
shadow.js.shim.module$$mui$material$Switch = shadow.js.nativeProvides["@mui/material/Switch"] = shadow$bridge("@mui/material/Switch");
module$shadow_js_shim_module$$mui$material$Switch.default = shadow.js.shim.module$$mui$material$Switch;
